import { render, staticRenderFns } from "./osIndex.vue?vue&type=template&id=7995a040&scoped=true"
import script from "./osIndex.vue?vue&type=script&lang=js"
export * from "./osIndex.vue?vue&type=script&lang=js"
import style0 from "./osIndex.vue?vue&type=style&index=0&id=7995a040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7995a040",
  null
  
)

export default component.exports